$(document).ready(function () {
  // ---------------------- add to cart drawer -------------------------
  // AJAX cart redirect to checkout
  $(document).on("click", ".add-to-cart-button:not(.out-stock-product)", function () {
    var variantID = $(this).attr("data-variant-id");
    $(this).find(".loading-button").addClass("active");
    $(this).find(".icon-addto-cart").addClass("active");
    addToCartJS(1, variantID);
  });

  function addToCartJS(qty, variantID, btn) {
    // Open the cart drawer
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        quantity: qty,
        id: variantID,
        sections: sectionsToRender,
        sections_url: sections_url,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        cartDrawer.renderContents(response);
        cartDrawer.open();
        if (cartDrawer && cartDrawer.classList.contains("is-empty"))
          cartDrawer.classList.remove("is-empty");
        $(".loading-button").removeClass("active");
        $(".icon-addto-cart").removeClass("active");
        initSwiper();
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
      });
  }

  // ---------------------- brand-image-slider -------------------------
    $(".brand-image-section-slider").slick({
      speed: 8000, // Duration of transition
      autoplay: true,
      autoplaySpeed: 0, // Set to 0 for continuous scrolling
      cssEase: "linear", // Smooth transition
      slidesToShow: 10,
      slidesToScroll: 1,
      infinite: true,
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true,
      dots: false,
      arrows: false,
      rows: 1, // Keep a single row for consistency
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 9,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 2,
          },
        },
      ],
    });

  // setTimeout(function () {
  //   $(".brand-image-section-slider").slick("refresh"); // Refresh the slick slider
  // }, 300);

  $(".review-content-section--slider-part").slick({
    dots: true,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0842/2706/4073/files/Arrow_3.png?v=1724411792"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0842/2706/4073/files/Arrow_2_1.png?v=1724411791"></button>`,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  setTimeout(function () {
    $(".review-content-section--slider-part").slick("refresh"); // Refresh the slick slider
  }, 300);

  $(".article-blog-slider").slick({
    dots: true,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0842/2706/4073/files/Arrow_3_1.png?v=1724909619"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0842/2706/4073/files/Arrow_2_2.png?v=1724909618"></button>`,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  // Function to set equal heights
  function setEqualHeights() {
    let maxHeight = 0;

    // Reset heights
    $(".article-blog-slider .slick-slide").css("height", "auto");

    // Calculate the max height
    $(".article-blog-slider .slick-slide").each(function () {
      let thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    // Set all slides to the max height
    $(".article-blog-slider .slick-slide").css("height", maxHeight + "px");
  }

  // Run the height adjustment after the slider is initialized
  setEqualHeights();

  // Re-run the height adjustment on slide change
  $(".article-blog-slider").on("afterChange", function () {
    setEqualHeights();
  });

  // Re-run the height adjustment on window resize
  $(window).on("resize", function () {
    setEqualHeights();
  });

  setTimeout(function () {
    $(".article-blog-slider").slick("refresh"); // Refresh the slick slider
  }, 300);
  // ---------------------- menu drawer collection -------------------------
  var Swipes2 = new Swiper(".menu-drawer-collection", {
    loop: false,
    slidesPerView: 2.5,
    spaceBetween: 15,
    slidesPerGroup: 1,
    slideToClickedSlide: false,

    // Pagination
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
  });
  // ---------------------- cart drawer collection -------------------------
 function initSwiper () {
    var Swipes3 = new Swiper(".cart-drawer-collection", {
      loop: false,
      slidesPerView: 2.5,
      spaceBetween: 30,
      slidesPerGroup: 1,
      slideToClickedSlide: false,

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  };
  
  initSwiper();
  
  let throttleTimeout = null;
  function observeCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
  
    if (cartDrawer) {
      const observer = new MutationObserver(function (mutations) {
        const clickedInsideCollection = mutations.some(mutation =>
          mutation.target.closest(".cart-drawer-collection")
        );
        if (!clickedInsideCollection && !throttleTimeout) {
          throttleTimeout = setTimeout(() => {
           initSwiper();
            throttleTimeout = null; // Reset throttle
          }, 1000); // 1-second throttle to prevent repeated calls
        }
      });
  
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
  }
  // Initialize observer
  observeCartDrawer();
  
  $(".formful__branding").css("display", "none");
  // Initialize the Slick slider
  $(".sell-content-section-slider").slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          autoplay: true,
        },
      },
    ],
  });

  // Function to set equal height for all slides
  function setEqualHeight() {
    var maxHeight = 0;

    // Loop through each slide to find the max height
    $(".sell-content-section-slider .slick-slide").each(function () {
      $(this).css("height", "auto"); // Reset height first
      var thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    // Apply the maximum height to all slides
    $(".sell-content-section-slider .slick-slide").css(
      "height",
      maxHeight + "px"
    );
  }

  // After the slider is fully initialized, adjust the heights
  $(".sell-content-section-slider").on("setPosition", function () {
    setEqualHeight();
  });

  // Adjust the heights whenever the window is resized
  $(window).on("resize", function () {
    setEqualHeight();
  });

  // Initial call to set equal height after Slick initializes
  setEqualHeight();

  $(document).on("click", ".menu-drawer-container .header__icon", function () {
    $(this).closest("body").find(".announcement-bar-v2-section").hide();
  });

  $(document).on("click", ".menu-icon-close", function () {
    $(this).closest("body").find(".header__icon--menu").trigger("click");
    $(this).closest("body").find(".announcement-bar-v2-section").show();
  });
  
  var featureSlider = parseInt($(".feature-slider").attr("data-item"), 10);
  var featureSliderMobile = parseInt(
    $(".feature-slider").attr("data-mobile-item"),
    10
  );
  $(".feature-slider").slick({
    dots: false,
    infinite: false,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0842/2706/4073/files/Arrow_2_Stroke.png?v=1727501265"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0842/2706/4073/files/Arrow_2_Stroke_1.png?v=1727501266"></button>`,
    speed: 300,
    slidesToShow: featureSlider,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: featureSliderMobile,
          slidesToScroll: 1,
          rows: 2,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //Navigation redirection code
  $(document).on("click",".header-menu-ajax-click", function () {
    var redirectUrl = $(this).attr("data-redirection");
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  });
  
  window.loadMoreEventCallback = function() {
    console.log('Function called from window');

  // Function to determine the number of products to show based on screen width
  function getProductsPerPage() {
    return $(window).width() > 1024 ? 9 : 6; // 9 for desktop, 6 for mobile
  }
  
  var productsPerPage = getProductsPerPage(); // Set initial products per page
  var totalProducts = $(".collection-product-part .grid__item").length; // Total number of products
  var productsShown = 0;
  
  // Initially hide all products
  $(".collection-product-part .grid__item").hide();
  
  // Show products function
  function showProducts() {
    // Show the next set of products based on productsShown and productsPerPage
    $(".collection-product-part .grid__item")
      .slice(0, productsShown + productsPerPage)
      .fadeIn();
    productsShown += productsPerPage;
  
    // If all products are shown, hide the "Load More" button
    if (productsShown >= totalProducts) {
      $(".load-more-button").hide();
    }
  }
  
  // Show the initial set of products on page load
  showProducts();
  
  // On "Load More" button click, show the next set of products
  $(".load-more-button .load-more-btn").on("click", function () {
    // $(this).find(".loading-button").addClass("active");
    // $(".load-more-btn .button").addClass("active");
    showProducts();
  });
  
   // Update products per page when the window is resized
    $(window).on("resize", function () {
      var currentProductsPerPage = getProductsPerPage(); // Update the products per page
  
      // Only re-adjust if the number of products per page has changed
      if (currentProductsPerPage !== productsPerPage) {
        productsPerPage = currentProductsPerPage;
        productsShown = productsPerPage; // Reset products shown count to match initial state
  
        // Ensure only the right number of products are visible
        $(".collection-product-part .grid__item").hide(); // Hide all products
        $(".collection-product-part .grid__item")
          .slice(0, productsShown)
          .show(); // Show only the first productsShown number of products
      }
    });
};
window.loadMoreEventCallback();

  // if ($("body").hasClass('template-collection')) {
  //   if ($(".filter-input-in-stock").length > 0) {
  //     $(".filter-input-in-stock").closest("label").trigger("click");
  //   }
  //   if ($(".mobile-filter-input-in-stock").length > 0) {
  //       $(".mobile-filter-input-in-stock").closest("label").trigger("click");
  //   }
  // } 

  var interval = setInterval(function () {
        if($(".review-carousel-section .trustpilot-widget").length > 0) {// Clear the interval once the element is found
          clearInterval(interval);
    
          // Move the element by cutting and pasting it
          $('.review-carousel-section .trustpilot-widget').detach().appendTo('.review-content-section .review-content-section--cover');
        } 
  }, 100);
  
});